import { Component, OnInit } from '@angular/core';
import * as echarts from 'echarts';
import { NgxSpinnerService } from 'ngx-spinner';
import axios from 'axios';

@Component({
  selector: 'app-dashboard-cut-f',
  templateUrl: './dashboard-cut-f.component.html',
  styleUrls: ['./dashboard-cut-f.component.css']
})
export class DashboardCutFComponent implements OnInit {
  constructor(
    private spinner: NgxSpinnerService
  ) {

  }
  data2e: string
  ngOnInit(): void {
    this.data2e = '&d=1=1';
    this.data_sup()
    this.lode_data()
  }

  lode_data() {
    let data = this.data2e;
    console.log('text data:', data);
    this.datafe(data);
    this.dataAlv(data);
    this.dataQtype(data);
  }

  chartOptions = {}; // ตัวแปรสำหรับเก็บตัวเลือกของแผนภูมิ
  chartUpdateOptions = {}; // ตัวแปรสำหรับการอัปเดตแผนภูมิ

  data_cutF_canetype = [];
  data_cutF_sum = [];
  year = '6869';

  datafe(data: string) {
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_cutF_canetype_year?yearID=${this.year}${data}`;
    //let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_cutF_canetype]&w=1=1";
    this.spinner.show()
    axios.get(url).then(res => {
      this.spinner.hide();
      let data = res.data;
      if (data.length > 0) {
        this.data_cutF_canetype = data//.filter(el => el.name == "d");
        this.data_cutF_sum = data.filter(el => el.datatype2 == "Sum");
        setTimeout(() => {
          this.data_chart_di('canetype');
        }, 10);
        //console.log('ArealevelOMonth:', this.ArealevelOMonth) 
        //console.log('sumCntFmSum:', this.sumCntFmSum) 
      }
    }).catch(err => { throw (err) })
  }
  data_cutF_aAlv = []
  dataAlv(data: string) {
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_cutF_Arealv_year?yearID=${this.year}${data}`;
    //let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_cutF_Arealv]&w=1=1";
    this.spinner.show()
    axios.get(url).then(res => {
      this.spinner.hide();
      let data = res.data;
      if (data.length > 0) {
        this.data_cutF_aAlv = data//.filter(el => el.name == "d");
        setTimeout(() => {
          this.data_chart_di('Arealv');
        }, 10);
        //console.log('ArealevelOMonth:', this.ArealevelOMonth) 
        //console.log('sumCntFmSum:', this.sumCntFmSum) 
      }
    }).catch(err => { throw (err) })
  }

  data_cutF_Qtype = []
  dataQtype(data: string) {
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_cutF_Qtype_year?yearID=${this.year}${data}`;
    //let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_cutF_Qtype]&w=1=1";
    this.spinner.show()
    axios.get(url).then(res => {
      this.spinner.hide();
      let data = res.data;
      if (data.length > 0) {
        this.data_cutF_Qtype = data//.filter(el => el.name == "d");
        setTimeout(() => {
          this.data_chart_di('Qtype');
        }, 10);
        //console.log('ArealevelOMonth:', this.ArealevelOMonth) 
        //console.log('sumCntFmSum:', this.sumCntFmSum) 
      }
    }).catch(err => { throw (err) })
  }

  compNums(a, b) {
    return a - b;
  }

  data_list = [, ,];
  data_sup() {
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/sum_sv?year=6667`;
    this.spinner.show()
    axios.get(url).then(res => {
      this.spinner.hide();
      let data = res.data;
      if (data.length > 0) {
        this.data_list = [
          [...new Set(data.map(function (elem) { return (elem.partcode) }))].sort(this.compNums)
          , [...new Set(data.map(function (elem) { return (elem.supzone) }))].sort(this.compNums)
          , [...new Set(data.map(function (elem) { return (elem.supcode) }))].sort(this.compNums)
        ]
      }
      console.log('data_list:', this.data_list)
    }).catch(err => { throw (err) })
  }

  shuffleArray(array) {
    for (var i = array.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      // Swap elements
      [array[i], array[j]] = [array[j], array[i]];
    }
  }

  reset(data) {
    for (var i = 0; i < data.length; i++) {
      const chartContainer = document.getElementById(data[i]);
      const myChart = echarts.init(chartContainer);
      if (myChart) {
        myChart.dispose();
      }
    }
    //console.log('data_all_p:', data);
  }

  dataArray = [[], [], [], []]
  data_chart_di(type: string) {
    /*for (var i = 0; i < this.data_ElById.length; i++) {
      let chart_id = this.data_ElById[i]
      chart = echarts.init(document.getElementById(chart_id));
      if (chart.echarts_instance) {
        chart.echarts_instance.dispose();
      }
    }*/

    var all_p, chart, name_c2 = 'chart-data_cutF';
    let dataf = []
    if (type == 'canetype') {
      dataf = this.data_cutF_canetype;
      all_p = [...new Set(dataf.map(function (elem) { return (name_c2 + type + elem.datatype2) }))];
      this.dataArray[0] = all_p;
    }
    else if (type == 'Arealv') {
      dataf = this.data_cutF_aAlv;
      all_p = [...new Set(dataf.map(function (elem) { return (name_c2 + type + elem.datatype) }))];
      this.dataArray[1] = all_p;
    }
    else if (type == 'Qtype') {
      dataf = this.data_cutF_Qtype;
      all_p = [...new Set(dataf.map(function (elem) { return (name_c2 + type + elem.datatype) }))];
      this.dataArray[2] = all_p;
    }
    this.reset(all_p);
    var colors = ['#37A2DA', '#32C5E9', '#67E0E3', '#9FE6B8', '#FFDB5C', '#ff9f7f', '#fb7293', '#E062AE', '#E690D1', '#e7bcf3', '#9d96f5', '#8378EA', '#96BFFF'];

    console.log(type, all_p);

    let name_chart = '', nameA_chart = 'พื้นที่ปลูก-';
    for (var i = 0; i < all_p.length; i++) {
      this.shuffleArray(colors);
      let data = dataf[i];
      let chart_id = all_p[i];
      chart = echarts.init(document.getElementById(chart_id));
      /*if (chart.echarts_instance) {
        chart.echarts_instance.dispose();
      }*/
      name_chart = data.datatype2;

      let data_set = [
        { value: parseFloat(data.landvalue_f.toFixed(2)), name: 'พื้นที่ตัดเสร็จ' },
        { value: parseFloat(data.landvalue_a.toFixed(2)), name: 'พื้นที่ทั้งหมด' },
      ]
      console.log('data_set:', data_set);
      const option = {
        color: colors,
        title: {
          text: nameA_chart + name_chart,
          //subtext: 'Fake Data',
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          /*top: 'bottom',
          left: 'center'*/
          top: '8%',
          orient: 'vertical',
          left: 'left'
        },
        series: [
          {
            type: 'pie',
            radius: [0, '30%'],
            label: {
              position: 'center',
              fontSize: 16,
              formatter: function (params) {
                return params.value
              },
            },
            data: [
              { value: data.yield_f, name: 'yield-ตัดเสร็จ' },
            ]
          },
          {
            name: nameA_chart + name_chart,
            type: 'pie',
            radius: ['35%', '65%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              position: 'outer',
              alignTo: 'none',
              backgroundColor: '#F6F8F1',
              borderColor: '#8C8D8S',
              borderRadius: 1,
              formatter: function (params) {
                return params.name + '\n ' + params.value.toLocaleString('th-TH');
              },
              /*formatter: ' {b| {b}：} \n {b|{c} ไร่} \n {per|{d}%}  ',              
              rich: {
                b: {
                  color: '#4C5058',
                  fontSize: 14,
                  fontWeight: 'bold',
                  lineHeight: 10
                },
                per: {
                  color: '#fff',
                  backgroundColor: '#4C5058',
                  padding: [3, 4],
                  borderRadius: 4
                }
              }*/
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 18,
                fontWeight: 'bold'
              }
            },
            data: data_set
          }
        ]
      };
      chart.setOption(option);
    }
  }
}
